import ConfirmModal from "../modals/ConfirmModal";
import ColorUpdateModal from "../modals/ColorUpdateModal";
import ModalPortal from "../modals/ModalPortal";
import CombineRangesModal from "../modals/CombineRangesModal";
import ConfirmSortModal from "../modals/ConfirmSortModal";

const BulkActionModalHost = ({
    activeAction,
    onConfirm,
    onClose,
    colors,
    colorOptions,
    dates
}) => {
    if (!activeAction) {
        return null;
    }

    let modal = null;

    switch (activeAction.modal) {
        case "DELETE_CONFIRM":
            modal = (
                <ConfirmModal
                    title="Delete selected items"
                    message="Are you sure you want to delete the selected entries?"
                    onConfirm={onConfirm}
                    onCancel={onClose}
                />
            );
            break;

        case "UPDATE_COLORS":
            modal = (
                <ColorUpdateModal
                    colors={colors}
                    colorOptions={colorOptions}
                    onConfirm={onConfirm}
                    onCancel={onClose}
                />
            );
            break;

        case "COMBINE_RANGES":
            modal = (
                <CombineRangesModal
                    onConfirm={onConfirm}
                    onCancel={onClose}
                    dates={dates}
                />
            );
            break;

        case "SORT_CONFIRM":
            modal = (
                <ConfirmSortModal
                    onConfirm={onConfirm}
                    onCancel={onClose}
                />
            );
            break;

        default:
            return null;
    }

    return (
        <ModalPortal>
            {modal}
        </ModalPortal>
    );
};

export default BulkActionModalHost;